export default "__VITE_ASSET__qJNrQ9LT__"